import React from "react";
import { Redirect } from "react-router-dom";
import OktaSignInWidget from "./OktaSignInWidget";
import { useOktaAuth } from "@okta/okta-react";
import "../../login.css";
import Logo from "../../images/logo-mha.svg";
import ReactivateAccountModal from "./ReactivateAccountModal";

const Login = ({ config }) => {
    const { oktaAuth, authState } = useOktaAuth();
    const [showReactivate, setShowReactivate] = React.useState(false);

    const onSuccess = (tokens) => {
        oktaAuth.handleLoginRedirect(tokens);
    };

    const onError = (err) => {
        console.log("Sign in error:", err);
    };

    if (!authState) {
        return <div>Loading ...</div>;
    }

    return authState.isAuthenticated ? (
        <Redirect to={{ pathname: "/" }} />
    ) : (
            <div id="div-login-container" className="text-center">

                {!showReactivate && (
                    <>
                        <img src={Logo} alt="MHA logo" />
                        <p className="m-2">Welcome to the MHA Member Portal.</p>

                        <OktaSignInWidget
                            config={config}
                            onSuccess={onSuccess}
                            onError={onError}
                        />

                        <p className="m-2">
                            <button
                                className="btn btn-link p-0"
                                style={{ cursor: "pointer", fontSize: "0.85rem" }}
                                onClick={() => setShowReactivate(true)}
                            >
                                Account not activated yet? Click here to re‑activate.
                            </button>
                        </p>
                    </>
                )}

                <ReactivateAccountModal
                    isOpen={showReactivate}
                    onClose={() => setShowReactivate(false)}
                />
            </div>
        );
};

export default Login;
